import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#create_from_template_svg__clip0_3231_1283)" }, [
      _createElementVNode("path", {
        d: "M5.68559 18.011L7.60006 7.15352C7.69557 6.61188 7.97357 6.18703 8.43405 5.87898C8.89454 5.57093 9.39561 5.46466 9.93725 5.56016L20.7455 7.46595C21.2872 7.56146 21.7168 7.83608 22.0345 8.28981C22.3522 8.74353 22.4633 9.24122 22.3678 9.78286L20.9787 17.6613L20.4577 20.6157V20.6157C20.2659 21.7035 19.2286 22.4299 18.1408 22.2381V22.2381L15.1864 21.7171L7.30791 20.3279C6.76627 20.2324 6.33659 19.9578 6.01889 19.5041C5.70118 19.0504 5.59008 18.5527 5.68559 18.011ZM3.17383 3.60602C3.17086 3.04701 3.36365 2.57752 3.7522 2.19756C4.14075 1.81759 4.61453 1.62612 5.17354 1.62314L16.193 1.61147C16.752 1.60849 17.2215 1.80128 17.6014 2.18983C17.9814 2.57838 18.1729 3.05216 18.1759 3.61117L18.1876 4.98408L16.1688 4.6281L16.1701 3.6129L5.17527 3.62891L5.17896 9.36673L3.96776 16.2358C3.7312 16.0417 3.54024 15.805 3.3949 15.5255C3.24956 15.246 3.17976 14.946 3.18551 14.6255L3.17383 3.60602ZM9.56534 7.52544L7.65521 18.3583L14.5489 19.5739L18.4881 20.2684L19.1827 16.3292L20.3982 9.43557L9.56534 7.52544ZM12.3473 17.6625L14.3169 18.0098L14.8379 15.0554L17.7923 15.5763L18.1396 13.6067L15.1852 13.0858L15.7061 10.1314L13.7365 9.78407L13.2156 12.7385L10.2611 12.2175L9.91383 14.1872L12.8683 14.7081L12.3473 17.6625Z",
        fill: "currentColor"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "create_from_template_svg__clip0_3231_1283" }, [
        _createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "currentColor"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }